import type { Resource } from '../types/content'

export const mainGuide: Resource = {
  id: 'handleiding',
  kind: 'guide',
  label: 'Praktische handleiding',
  name: 'Punniken met Liefde',
  benefit: 'De basis om te beginnen, met een duidelijk stappenplan.',
  description:
    'Ontdek materialen en gereedschap, leer punnikkoord maken en maak kennis met vormen en afwerken. Een handleiding om bij de hand te houden terwijl je oefent en je eerste ideeën vormgeeft.',
  image: 'https://cdn.magicpatterns.com/uploads/bNzXkY2MrQCwsHof5kbqYN/mock_up.png',
  imageAlt:
    'Omslag van de handleiding Punniken met Liefde, met de naam Sofia en een regenboog, een letter A met een bloem, een luchtballon, een hartje en bloemsleutelhangers van punnikkoord',
}

export const templateLibrary: Resource = {
  id: 'collectie',
  kind: 'collection',
  label: 'Sjablonen',
  name: 'De Creatieve Collectie',
  benefit: 'Vormen om te printen en te volgen',
  description:
    'Een verzameling sjablonen om te printen, zodat je een vorm kunt kiezen, kunt oefenen en steeds nieuwe ideeën kunt uitwerken.',
  image: 'https://cdn.magicpatterns.com/uploads/v3df7ukh1mK1XveSLuoUSU/03-geboorte-doop-communie.png',
  imageAlt:
    'Omslag van De Creatieve Collectie van Punniken met Liefde, met DIY in roze punnikkoord, op een tafel vol sjablonen met letters, cijfers, hartjes, bloemen, een beertje en een vlinder',
}

export const bonuses: Resource[] = [
  {
    id: 'creatieve-ideeen',
    kind: 'bonus',
    number: 1,
    label: 'Bonus 1',
    name: 'Creatieve ideeën met punnikkoord',
    benefit: 'Vind inspiratie voor je volgende project.',
    description:
      'Een verzameling ideeën om vormen, kleuren en decoratieve details te ontdekken en ze op je eigen manier toe te passen.',
    image: 'https://cdn.magicpatterns.com/uploads/cdhxrNXiuZvMBWyedKa3L1/04-creatieve-collectie.png',
    imageAlt:
      'Omslag van Creatieve ideeën met punnikkoord op een houten tafel, omringd door een punnikmolen, bolletjes garen, metaaldraad, tangen en vormen van punnikkoord: een maan, een ster, een dinosaurus, een huisje en een vlinder',
  },
  {
    id: 'sleutelhangers',
    kind: 'bonus',
    number: 2,
    label: 'Bonus 2',
    name: 'Persoonlijke sleutelhangers met punnikkoord',
    benefit: 'Kleine accessoires met een persoonlijk tintje.',
    description:
      'Ontdek materialen, vormen en afwerkingen om sleutelhangers te maken met beginletters, hartjes, bloemen en andere kleine details.',
    image: 'https://cdn.magicpatterns.com/uploads/gYdhoYNGs5gpLjFK6wkwnd/07-compleet-pakket.png',
    imageAlt:
      'Omslag van Persoonlijke sleutelhangers met punnikkoord, omringd door bloemvormige sleutelhangers van roze, lila en mintgroen punnikkoord',
  },
  {
    id: 'pennen',
    kind: 'bonus',
    number: 3,
    label: 'Bonus 3',
    name: 'Versierde pennen met punnikkoord',
    benefit: 'Een creatief detail, ook in alledaagse spullen.',
    description:
      'Ideeën en tips om pennen te versieren met kleine decoraties van punnikkoord, met aandacht voor verhoudingen, bevestiging en gebruiksgemak.',
    image: 'https://cdn.magicpatterns.com/uploads/j9XTFqZLiMkRWWCgZ23DTb/08-persoonlijke-sleutelhangers.png',
    imageAlt:
      'Omslag van Versierde pennen met punnikkoord tussen pastelkleurige pennen met bloemen van punnikkoord',
  },
  {
    id: 'bedankjes',
    kind: 'bonus',
    number: 4,
    label: 'Bonus 4',
    name: 'Kleine cadeaus en bedankjes met punnikkoord',
    benefit: 'Kleine attenties voor bijzondere momenten.',
    description:
      'Een verzameling inspiratie voor bedankjes en kleine cadeautjes, met ideeën voor kleuren en presentatie.',
    image: 'https://cdn.magicpatterns.com/uploads/pph4vWPpnWtkye7o57U84Z/05-creatieve-ideeen.png',
    imageAlt:
      'Omslag van Kleine cadeaus en bedankjes met punnikkoord tussen zakjes en doosjes versierd met hartjes, sterren en bloemen van punnikkoord',
  },
]

/** Volgorde van het pakket: handleiding, collectie, daarna de 4 bonussen. */
export const allResources: Resource[] = [mainGuide, templateLibrary, ...bonuses]
